export default __webpack_public_path__ + "7404be38c95fbfe3987ff60009dde918.png";